<template>
  <Modal :value="value" @input="$emit('input', $event)">
    <p class="pb-6 text-2xl font-bold leading-tight">
      {{ $t('popups.exit.title') }}
    </p>

    <div class="flex flex-col-reverse sm:flex-row">
      <Button
        id="flight-voucher-return-lh"
        variant="secondary"
        class="mt-4 sm:mt-0 sm:mr-4"
        :href="backToLHLink"
      >
        {{ $t('popups.exit.cancelButton') }}
      </Button>
      <Button
        id="flight-voucher-continue"
        @click="$emit('input', false)"
      >
        {{ $t('popups.exit.continueButton') }}
      </Button>
    </div>
  </Modal>
</template>

<script lang="ts">
import CancelRedemptionPopup from '~app/psp/base/cancel-redemption-popup.ts'
import Modal from '~brand-components/brussels/modal/modal.vue'
import Button from '~brand-components/brussels/button/button.vue'

export default CancelRedemptionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
